<template>
  <div class="compare-product" style="margin-bottom: 50px;">
    <el-table :data="productSimilarAsinDataDTOList" border size="mini">
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="关联商品图片" width="50px" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.productImgUrl" style="height: 40px; width: 40px" fit="fill">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="asin" label="关联商品asin" width="100px">
      </el-table-column>
      <el-table-column prop="shopName" label="关联商品商家名称" width="100px">
      </el-table-column>
      <el-table-column prop="productRank" label="关联商品排名" width="50px" align="center">
      </el-table-column>
      <el-table-column width="90px" align="center">
        <template slot="header" slot-scope="scope">
          <div>本品</div>
          <el-image :src="competitionProductDataDTO.imgUrl" style="height: 40px; width: 40px" fit="fill">
          </el-image>
          <div>{{competitionProductDataDTO.asin}}</div>
          <div>商店名称:{{competitionProductDataDTO.shopName}}</div>
          <div>单价:{{competitionProductDataDTO.price}}</div>
        </template>
        <template v-slot="scope">
          {{scope.row.rankOfMolova}}
        </template>
      </el-table-column>
      <el-table-column width="90px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct1!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品1</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct1" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{competitionProductDataDTO.asinOfCompetitionProduct1}}</div>
          <div>商店名称:{{competitionProductDataDTO.shopNameOfCompetitionProduct1}}</div>
          <div>单价:{{competitionProductDataDTO.priceOfCompetitionProduct1}}</div>
        </template>
        <template slot-scope="scope">
          {{scope.row.rankOfCompetitionProduct1}}
        </template>
      </el-table-column>
      <el-table-column width="90px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct2!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品2</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct2" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{competitionProductDataDTO.asinOfCompetitionProduct2}}</div>
          <div>商店名称:{{competitionProductDataDTO.shopNameOfCompetitionProduct2}}</div>
          <div>单价:{{competitionProductDataDTO.priceOfCompetitionProduct2}}</div>
        </template>
        <template slot-scope="scope">
          {{scope.row.rankOfCompetitionProduct2}}
        </template>
      </el-table-column>
      <el-table-column width="90px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct3!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品3</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct3" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{competitionProductDataDTO.asinOfCompetitionProduct3}}</div>
          <div>商店名称:{{competitionProductDataDTO.shopNameOfCompetitionProduct3}}</div>
          <div>单价:{{competitionProductDataDTO.priceOfCompetitionProduct3}}</div>
        </template>
        <template slot-scope="scope">
          {{scope.row.rankOfCompetitionProduct3}}
        </template>
      </el-table-column>
      <el-table-column width="90px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct4!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品4</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct4" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{competitionProductDataDTO.asinOfCompetitionProduct4}}</div>
          <div>商店名称:{{competitionProductDataDTO.shopNameOfCompetitionProduct4}}</div>
          <div>单价:{{competitionProductDataDTO.priceOfCompetitionProduct4}}</div>
        </template>
        <template slot-scope="scope">
          {{scope.row.rankOfCompetitionProduct4}}
        </template>
      </el-table-column>
      <el-table-column width="90px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct5!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品5</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct5" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{competitionProductDataDTO.asinOfCompetitionProduct5}}</div>
          <div>商店名称:{{competitionProductDataDTO.shopNameOfCompetitionProduct5}}</div>
          <div>单价:{{competitionProductDataDTO.priceOfCompetitionProduct5}}</div>
        </template>
        <template slot-scope="scope">
          {{scope.row.rankOfCompetitionProduct5}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    props: {
      productSimilarAsinDataDTOList: {
        type: Array,
        default() {
          return [];
        }
      },
      productSearchKeywordDataDTOList: {
        type: Array,
        default() {
          return [];
        }
      },
      competitionProductDataDTO: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    data() {
      return {};
    }
  }
</script>

<style>
</style>
